import styled from '../../../../theme'

const TimePickerWrapper = styled.div<{ oneColumn?: boolean }>`
  display: flex;
  width: ${({ oneColumn }) => (oneColumn ? 120 : 250)}px;
  height: 200px;
  padding: 10px 0px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  background-color: white;
  user-select: none;
  border-radius: 5px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
`

export default TimePickerWrapper
